"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../assets/css/input.css");

require("./InputLocked.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var InputLocked =
/*#__PURE__*/
function (_Component) {
  _inherits(InputLocked, _Component);

  function InputLocked() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InputLocked);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InputLocked)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value || '',
      locked: true,
      isFilled: _this.props.value ? true : false,
      btntxt: _this.props.btntxt
    });

    _defineProperty(_assertThisInitialized(_this), "textInput", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.setState({
        locked: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        value: event.target.value
      });

      _this.checkFilled(event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "checkFilled", function (value) {
      if (value) _this.setState({
        isFilled: true
      });else _this.setState({
        isFilled: false
      });
    });

    return _this;
  }

  _createClass(InputLocked, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.locked !== this.state.locked) this.textInput.current.focus();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        value: this.props.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var wrapperClass = (0, _classnames.default)('input-locked', {
        'input-locked--disabled': this.state.locked
      }, this.props.className ? this.props.className.split(' ') : '');
      var inputClass = (0, _classnames.default)('input__field', {
        'input__field--filled': this.state.isFilled
      }, {
        'input__field--locked': this.state.locked
      });
      return _react.default.createElement("div", {
        className: wrapperClass
      }, _react.default.createElement("div", {
        className: "input"
      }, _react.default.createElement("input", {
        autoComplete: "new-password",
        type: "text",
        name: this.props.name,
        id: this.props.id,
        ref: this.textInput,
        value: this.state.value,
        className: inputClass,
        onChange: this.state.locked ? function () {
          return null;
        } : this.handleChange,
        required: this.props.required
      }), _react.default.createElement("label", {
        className: "input__label",
        htmlFor: this.props.id
      }, this.props.label)), this.props.component ? this.props.component : _react.default.createElement("span", {
        className: this.state.locked ? 'input-locked__button' : 'input-locked__button--hidden',
        onClick: this.handleClick
      }, this.props.btntxt));
    }
  }]);

  return InputLocked;
}(_react.Component);

InputLocked.propTypes = {
  /** Pode ser um componente react para renderizar no lugar do botão alterar */
  component: _propTypes.default.object,

  /** Classe adicional para o wrapper */
  className: _propTypes.default.string,

  /** Atributo value do input, caso precise vir pré-definido */
  value: _propTypes.default.string,

  /** Atributo name do input */
  name: _propTypes.default.string,

  /** Define se o input está travado para edição */
  locked: _propTypes.default.bool,

  /** Texto do botão alterar */
  btntxt: _propTypes.default.string,

  /** ID do input para servir como `for` do label */
  id: _propTypes.default.string.isRequired,

  /** Label que referencia o input */
  label: _propTypes.default.string.isRequired,

  /** Atributo required do input */
  required: _propTypes.default.bool
};
var _default = InputLocked;
exports.default = _default;